/* Floractive Wishlist — storage, heart buttons, header counters.
   Data lives in the browser (localStorage key fa_wishlist) as an array of product IDs (strings).
   Markup hooks: [data-wishlist-toggle][data-product-id]  → heart buttons
                 [data-wishlist-count]                    → counters (get .hidden when 0)
   Events: document "wishlist:change" {detail:{ids}} after every change. */
(function () {
  var KEY = 'fa_wishlist';
  function read() {
    try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a.map(String) : []; }
    catch (e) { return []; }
  }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} emit(); }
  function emit() {
    syncHearts(); syncCounts();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { ids: read() } }));
  }
  function has(id) { return read().indexOf(String(id)) !== -1; }
  function add(id) { var a = read(); id = String(id); if (a.indexOf(id) === -1) { a.unshift(id); write(a); } }
  function remove(id) { write(read().filter(function (x) { return x !== String(id); })); }
  function toggle(id) { if (has(id)) remove(id); else add(id); return has(id); }

  function syncHearts() {
    var a = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      var on = a.indexOf(String(b.getAttribute('data-product-id'))) !== -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? b.getAttribute('data-label-remove') : b.getAttribute('data-label-add');
      if (label) {
        b.setAttribute('aria-label', label); b.title = label;
        var t = b.querySelector('[data-wishlist-text]'); if (t) t.textContent = label;
      }
    });
  }
  function syncCounts() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n < 100 ? n : '~';
      el.classList.toggle('hidden', n === 0);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    toggle(b.getAttribute('data-product-id'));
    b.classList.add('fa-wish--pop');
    setTimeout(function () { b.classList.remove('fa-wish--pop'); }, 350);
  }, true);

  window.FAWishlist = { ids: read, has: has, add: add, remove: remove, toggle: toggle,
    count: function () { return read().length; }, syncHearts: syncHearts, syncCounts: syncCounts };

  var t;
  function init() {
    syncHearts(); syncCounts();
    // cards are injected dynamically (filters, quick view, drawers) — keep hearts in sync
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(syncHearts, 60); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('storage', function (e) { if (e.key === KEY) emit(); });
})();
